import { makeVerification } from './makeVerification';
export const verifyCreate = makeVerification('create_work_group_memberships');
